import { useEffect, useState } from "react"
import { RequestConfigs } from "../../api"
import { useFormHandling } from "../../hooks/formUtils"
import { Link } from "react-router-dom"
import { Col, Row } from "../../style/base.style"
import styled from "styled-components"
import { translate } from "react-range/lib/utils"
import { useDictionary } from "../../contexts/dictionary"
import { useContactType } from "../../contexts/ContactContext"

export const Notifications = () => {
    const { handleClick, serverRes } = useFormHandling({ requestType: RequestConfigs.getNotifications })
    const readNotification = useFormHandling({ requestType: RequestConfigs.readNotification })
    const {translate} = useDictionary()
    const {contact} = useContactType()

    useEffect(() => {
        handleClick()
    }, [contact])

    useEffect(() => {
        handleClick()
    }, [])
   

    const [notifications, setNotifications] = useState<Notification[] | null>(null)

    useEffect(() => {
        if (serverRes?.notifications) {
            setNotifications(serverRes.notifications)
        }
    }, [serverRes])

    useEffect(() => {
        if (readNotification.serverRes?.notifications) {
            setNotifications(readNotification.serverRes.notifications)
        }
    }, [readNotification])

    const handleRead = (notification:Notification) => {
        if(notification.read) return
        readNotification.handleClick({id:notification.id})
    }

    const showNotifications = notifications && notifications?.length > 0

    return (
        <>
            <table className="table dashboard-table" style={{ borderSpacing: '0 5px',  borderCollapse: 'separate' }}>
                <tbody style={{ width: "100%" }}>
                    { showNotifications &&
                        notifications?.map((notification, index) => (
                            <tr key={index}>
                                <Td style={{backgroundColor:notification.read?'#420dac39':'transparent',borderRadius:'10px'}} onClick={()=>handleRead(notification)}>
                                    <Row $width="100%">

                                        <Row className="table-noti-info" $justifyContent="flex-start" $width="90%">
                                            <div className="table-noti-icon color-violet" >
                                                <i className="fa-solid fa-bell" />
                                            </div>
                                            <div className="table-noti-message">
                                                <h6>
                                                    <Link to="#">
                                                        {notification.message}
                                                    </Link>
                                                </h6>
                                                <span className="message-time">{new Date(notification.createdOn).toDateString()}</span>
                                            </div>
                                            
                                        </Row>
                                        <Row $width="15px" $justifyContent="flex-end" $flex="1">
                                            <div className="table-noti-icon color-violet" >
                                                <i className="fa-solid fa-envelope-circle-check" />
                                            </div>
                                        </Row>
                                    </Row>
                                </Td>
                            </tr>
                        ))
                    }
                    {
                        !showNotifications && 
                        <>
                        <Col $width="100%" $alignItems="center" $justifyContent="center" $padding="50px">
                            <h3>{translate('no_notifications')}</h3>
                        </Col>
                        </>
                    }

                </tbody>
            </table>
        </>
    )
}


const Td = styled.td`
    width: 100%;
    /* border-radius: 10px; */
    cursor: pointer;

`